import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueProgressBar from 'vue-progressbar';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import moment from 'moment';

import axios from 'axios';
import App from './App.vue';
import router from './router';
import store from './store';

const options = {
  color: '#4B4597',
  failedColor: '#9E2D27',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
  position: 'relative',
};

library.add(faChevronRight, faSearch);
Vue.use(Vuelidate);
Vue.use(VueProgressBar, options);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.filter('formatDate', (value) => {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm');
  }
  return value;
});

Vue.filter('date', (value) => {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY');
  }
  return value;
});

new Vue({
  router,
  store,
  render: h => h(App),
  async mounted() {
    try {
      const appInfo = await axios.get('/app-info');
      document.title = appInfo.data.title;
      this.$store.commit('updateShouldShowSds', appInfo.data.shouldShowSds);
      this.$store.commit('updateShouldShowSpec', appInfo.data.shouldShowSpec);
    } catch (error) {
      console.error('Failed to fetch app information:', error);
    }
  }
}).$mount('#app');
